export default __webpack_public_path__ + "static/media/foundation.5a3e1bf6.svg";